import { render, staticRenderFns } from "./BajasComercialesAsignarTramo.vue?vue&type=template&id=58e8fca3&"
import script from "./BajasComercialesAsignarTramo.vue?vue&type=script&lang=ts&"
export * from "./BajasComercialesAsignarTramo.vue?vue&type=script&lang=ts&"
import style0 from "./BajasComercialesAsignarTramo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports